import type { MetadataDay } from "../metadata-history/metadata-targets";
import type { BuilderPreviewMode } from "../../stores/metadata-builder-store";
import { weekdayKeys } from "../schedule-time/schedule-dates";
import type { DayLayoutMode } from "./day-layouts";

// A day missing from the map is hidden on the preview.
export type PreviewDayModes = Partial<Record<MetadataDay, DayLayoutMode>>;

const mixedWeek: DayLayoutMode[] = ["one_slot", "two_slot", "offline", "one_slot", "offline", "two_slot", "one_slot"];
const slotCount: Record<DayLayoutMode, number> = { offline: 0, one_slot: 1, two_slot: 2 };

export function previewModesFor(mode: BuilderPreviewMode): PreviewDayModes {
  const entries = weekdayKeys.map((day, index) => {
    const dayMode = mode === "mixed" ? mixedWeek[index]! : mode;
    return [day, dayMode] as const;
  });
  return Object.fromEntries(entries);
}

export function previewModesMatch(modes: PreviewDayModes, mode: BuilderPreviewMode) {
  const expected = previewModesFor(mode);
  return weekdayKeys.every(day => modes[day] === expected[day]);
}

export function previewSlotCounts(modes: PreviewDayModes) {
  return weekdayKeys.map(day => {
    const mode = modes[day];
    if (!mode) return 0;
    return slotCount[mode];
  });
}

export function visiblePreviewDays(modes: PreviewDayModes): MetadataDay[] | null {
  const visible = weekdayKeys.filter(day => modes[day] !== undefined);
  const fullWeek = visible.length === weekdayKeys.length;
  if (fullWeek) return null;
  return visible;
}

// Select a shown cell again to hide that day.
export function togglePreviewMode(modes: PreviewDayModes, day: MetadataDay, mode: DayLayoutMode): PreviewDayModes {
  const shown = modes[day] === mode;
  if (!shown) return { ...modes, [day]: mode };
  const next = { ...modes };
  delete next[day];
  return next;
}
